import * as React from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import mediaUrl from "../util/mediaUrl";

export default function BallCabinetUnlock(): React.JSX.Element {
    return (
        <Paper sx={{ p: 2, minHeight: "90vh" }}>
            <Stack spacing={3}>
                <Typography variant="h3" component="h1">
                    Ball Cabinet Unlock
                </Typography>

                <Typography>
                    If your club has a locking Volley cabinet, use the following
                    code to access the batteries and balls:
                </Typography>

                <Typography
                    align="center"
                    sx={{
                        letterSpacing: 30,
                        fontFamily: "monospace",
                        fontSize: "5rem",
                    }}
                >
                    717
                </Typography>

                <Typography variant="h5" component="h2">
                    Enter the code on the lock face:
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <img
                        src={mediaUrl("instructions/cabinet-locked.jpg")}
                        alt="Cabinet lock face showing code dials"
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </Box>

                <Typography variant="h5" component="h2">
                    Twist lock to the right and open doors:
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <img
                        src={mediaUrl("instructions/cabinet-unlocked.jpg")}
                        alt="Cabinet doors open showing contents"
                        style={{ maxWidth: "100%", height: "auto" }}
                    />
                </Box>

                <Typography sx={{ mt: 2 }}>
                    Please be sure to re-lock the cabinet after your session by
                    twisting the lock back to the original position and changing
                    the numbers on the dials away from the code.
                </Typography>
            </Stack>
        </Paper>
    );
}
